import axios from 'axios';
import { API } from '../config';

axios.defaults.headers.post['Access-Control-Allow-Origin'] = "*";
axios.defaults.headers.get['Access-Control-Allow-Origin'] = '*';

class DoencaService {
    novoDoenca(doenca) {
        return axios.post(API + "/doenca", doenca);
    }

    listarDoenca() {
        return axios.get(API + "/doenca")
    }

    getDoenca(id) {
        return axios.get(API + "/doenca/" + id)
    }
    atualizarDoenca(id, doenca) {
        return axios.post(API + "/doenca/" + id, doenca);
    }
    inativarDoenca(id, doenca) {
        return axios.post(API + "/doenca/" + id + "/inativar", doenca);
    }
    reativarDoenca(id, doenca) {
        return axios.post(API + "/doenca/" + id + "/reativar", doenca);
    }
    pesquisarDoenca(descricao, status) {
        return axios.get(API + "/doenca/search", {
            params: {
                descricao: descricao !== "" ? descricao : undefined,
                status: status !== "" ? status : undefined
            }
        });
    }

    listarDeficiencia() {
        return axios.get(API + "/tipos-deficiencias")
    }

    listarDoencaAtiva() {
        return axios.get(API + "/doenca/ativas")
    }

}

const instanceDoenca= new DoencaService();
export default instanceDoenca;